import { type ReactNode, createContext } from 'react'

interface FrameBuilderShopContextProps {
  taxRate: number
  currency?: string
}

export const FrameBuilderShopContext =
  createContext<FrameBuilderShopContextProps>({
    taxRate: 0,
  })

interface FrameBuilderShopProviderProps {
  taxRate: number
  currency?: string
  children: ReactNode
}

export const FrameBuilderShopProvider = ({
  taxRate,
  currency,
  children,
}: FrameBuilderShopProviderProps) => {
  return (
    <FrameBuilderShopContext.Provider
      value={{
        taxRate,
        currency,
      }}
    >
      {children}
    </FrameBuilderShopContext.Provider>
  )
}
